module.exports = __webpack_public_path__ + "img/partner-logo.7707b18f.svg";